var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_43952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.831 0.317383H2.77707C1.2416 0.317383 0 1.5296 0 3.02834V35.2145C0 36.7132 1.2416 37.9328 2.77707 37.9328H34.831C36.3664 37.9328 37.6154 36.7132 37.6154 35.2218V3.02834C37.6154 1.5296 36.3664 0.317383 34.831 0.317383ZM11.1597 32.3713H5.57619V14.4158H11.1597V32.3713ZM8.36796 11.9693C6.57535 11.9693 5.12804 10.522 5.12804 8.73676C5.12804 6.9515 6.57535 5.50419 8.36796 5.50419C10.1532 5.50419 11.6005 6.9515 11.6005 8.73676C11.6005 10.5147 10.1532 11.9693 8.36796 11.9693ZM32.0539 32.3713H26.4777V23.6433C26.4777 21.5642 26.441 18.8826 23.5757 18.8826C20.6738 18.8826 20.233 21.1528 20.233 23.4964V32.3713H14.6641V14.4158H20.0126V16.8696H20.086C20.8281 15.459 22.65 13.9677 25.361 13.9677C31.0107 13.9677 32.0539 17.6851 32.0539 22.5193V32.3713Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_43952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.6154,
    height: 37.6154,
    fill: "white",
    transform: "translate(0 0.317383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinDark);
export default __webpack_public_path__ + "static/media/linkedin-dark.1e8019cd67dad9a01fd4e52d94b91c3e.svg";
export { ForwardRef as ReactComponent };